import React from 'react'
import { CustomDialog } from '../common/customComponents'
import { SnapshotType } from './models'
import { t } from '../../infrastructure/i18nextHelper'
import { useSnapshotLabel } from './useSnapshotLabel'

type SnapshotConfirmationDialogsProps = {
    snapshotType: SnapshotType | null
    isSnapshotCreationDialogOpen: boolean
    hideCreationDialog: () => void
    createSnapshot: (type: SnapshotType) => void
    isSnapshotCancellationDialogOpen: boolean
    hideCancellationDialog: () => void
    cancelSnapshot: (type: SnapshotType) => void
    fullMonthSelected?: boolean
}

export let SnapshotConfirmationDialogs = ({
    snapshotType,
    isSnapshotCreationDialogOpen,
    hideCreationDialog,
    createSnapshot,
    isSnapshotCancellationDialogOpen,
    hideCancellationDialog,
    cancelSnapshot,
    fullMonthSelected
}: SnapshotConfirmationDialogsProps): JSX.Element => {

    if (!snapshotType) return <></>

    let { getSnapshotLabel } = useSnapshotLabel()
    let snapshotLabel = getSnapshotLabel(snapshotType)

    return (
        <>
            <CustomDialog isOpen={isSnapshotCreationDialogOpen}
                title={t('mktSales.forecast.saveForecastDialogTitle', { type: snapshotLabel })}
                contentText={t(!fullMonthSelected
                    ? 'mktSales.forecast.saveForecastDialogTextWithWarning'
                    : 'mktSales.forecast.saveForecastDialogText', { type: snapshotLabel })}
                confirmButtonText={t('mktSales.forecast.saveForecast', { type: snapshotLabel })}
                onConfirm={() => createSnapshot(snapshotType)}
                onClose={() => hideCreationDialog()}
                onCancel={() => hideCreationDialog()} />

            <CustomDialog isOpen={isSnapshotCancellationDialogOpen}
                title={t('mktSales.forecast.cancelForecastDialogTitle', { type: snapshotLabel })}
                contentText={t('mktSales.forecast.cancelForecastDialogText', { type: snapshotLabel })}
                cancelButtonText={t('components.dialogClose')}
                confirmButtonText={t('mktSales.forecast.cancelForecast', { type: snapshotLabel })}
                onConfirm={() => cancelSnapshot(snapshotType)}
                onClose={() => hideCancellationDialog()}
                onCancel={() => hideCancellationDialog()} />
        </>)
}
